import React, { Component } from 'react'
import queryString from 'query-string'
import config from '../../utils/config'
import FetchWrapper from '../../utils/fetch_wrapper'

class LiveAgent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      enabled: false
    }
  }

  componentDidMount() {
    this.updateLiveAgent()
  }

  componentDidUpdate() {
    this.updateLiveAgent()
  }

  async updateLiveAgent() {
    const plId = queryString.parse(window.location.search).plId
    const regCode = queryString.parse(window.location.search).regCode
    if (regCode && !this.state.enabled) {
      let enabled = await this.getLiveAgent(regCode)
      if (enabled) {
        this.setState({ enabled })
        window.liveagent.init(config.liveAgentInitURL, config.liveAgentChatId, config.liveAgentOrgId);
        if (regCode) window.liveagent.addCustomDetail('Registration Code', regCode)
        if (plId) {
          window.liveagent.findOrCreate('MC_Participant_Lead__c')
            .map('PL_ID__c', 'PL_ID', true, false, false)
            .showOnCreate()
        }
        if (!window._laq)
          window._laq = []    
          window._laq.push(function liveagentSetup() {
          window.liveagent.showWhenOnline(config.liveAgentButtonId, document.getElementById('liveagent_button_online_' + config.liveAgentButtonId))
        })
      }
    }
  }

  async getLiveAgent(regCode) {
    try {
      let response = await FetchWrapper.fetch(config.endpoint_get_liveagent + '&regCode=' + regCode, {
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include'
      })
      return response.data
    }
    catch(error) {
      return false
    }
  }

  render() {
    if (!this.state.enabled) return <div></div>
    return (
      <div className="liveagent">
        <img 
          id={'liveagent_button_online_' + config.liveAgentButtonId}
          tabIndex="0"
          style={{ display: "none" }}
          onClick={() => window.liveagent.startChat(config.liveAgentButtonId)}
          src={config.liveAgentImage}
          aria-label="Live agent button. Click to contact one of our care specialists"
        />
      </div>
    )
  }
}

export default LiveAgent